import isEmpty from 'lodash/isEmpty';
import { FiArrowRightCircle } from 'react-icons/fi';
import { SHOW_COMMEMORATE } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';
import Link from '../link';

export default function WidgetHeading({ heading = '', customHeading, className = '', eventDataLayer = {}, showReadmore = false, link = '', isSectionLive = false }) {
  if (isEmpty(heading)) return null;

  return (
    <WidgetWrapper className={`widget-heading ${className}`} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
      {isSectionLive ? (
        <h2 className='heading --live'>
          <span className='live-button'>
            <svg x='0px' y='0px' width='17px' height='15.8px' viewBox='0 0 17 15.8'>
              <path d='M8.5,6.8c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7C10.2,7.6,9.5,6.8,8.5,6.8z'></path>
              <path d='M13.6,8.5c0-2.8-2.2-5.1-5-5.2c-2.8,0-5.1,2.2-5.2,5c0,0,0,0.1,0,0.1c0,1.8,1,3.5,2.6,4.4l0.9-1.4c-1.6-1-2.1-3-1.2-4.6s3-2.1,4.6-1.2c1,0.6,1.7,1.7,1.7,2.9c0,1.2-0.6,2.3-1.7,2.9l0.9,1.4C12.7,12,13.6,10.3,13.6,8.5L13.6,8.5z'></path>
              <path d='M8.5,0C3.8,0,0,3.8,0,8.5c0,3,1.6,5.8,4.3,7.3l0.9-1.4c-3.3-1.9-4.4-6.1-2.5-9.3s6.1-4.4,9.3-2.5c2.1,1.2,3.4,3.5,3.4,5.9c0,2.4-1.3,4.7-3.4,5.9l0.9,1.4c4.1-2.3,5.5-7.5,3.1-11.6C14.4,1.6,11.6,0,8.5,0z'></path>
            </svg>
            LIVE
          </span>{' '}
          เกาะติดเลือกตั้ง
        </h2>
      ) : link ? (
        <Link
          href={link} // ! DATALAYER
          onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}
        >
          {customHeading ?? <h2 className={`heading ${link ? '--hover' : ''}`}>{heading}</h2>}
        </Link>
      ) : (
        (customHeading ?? <h2 className={`heading ${link ? '--hover' : ''}`}>{heading}</h2>)
      )}
      {showReadmore && (
        <Link
          href={link} // ! DATALAYER
          onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}
        >
          <p className='text-read'>
            ดูทั้งหมด <FiArrowRightCircle />
          </p>
        </Link>
      )}
    </WidgetWrapper>
  );
}

const WidgetWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: baseline;
  border-bottom: 3px solid var(--primary-color);

  h2 {
    background: var(--white-color);
    color: var(--text-color);
    width: fit-content;
    font-family: 'DBHelvethaicaXBd', sans-serif;
    padding: 5px 15px 5px 0px;
    border-radius: 10px 10px 0 0px;
    font-size: 28pt;
    font-weight: 400;
    margin-bottom: -13px;
    letter-spacing: 0px;
    text-transform: uppercase;

    @media (max-width: 768px) {
      font-size: 24pt;
    }
    // @media (max-width: 768px) {
    //   font-family: 'DBHelvethaicaXBd', sans-serif;
    //   font-weight: 500;
    // }
    span {
      color: #f10300;
    }
  }
  a h2 {
    cursor: pointer;
    transition: all 0.5s ease-out;
    :hover {
      transform: scale(1.05);
    }
  }
  .text-read {
    color: var(--primary-color);
    cursor: pointer;
    font-size: 12pt;
    font-weight: 500;
    background: var(--white-color);
    margin-bottom: -10px;
    padding-left: 10px;

    /* padding-bottom: 8px; */
    svg {
      color: var(--primary-color);
      margin-left: -3px;
    }
    &:hover {
      svg {
        color: var(--hover-color);
      }
      color: var(--hover-color);
    }
  }

  .heading {
    &.--hover {
      &:hover {
        color: #0600e7;
      }
    }
    &.--live {
      font-size: 24pt;
    }
  }

  .live-button {
    svg {
      margin-right: 7px;
      margin-bottom: 4px;
    }
    svg path {
      fill: red;
      /* Copy this @keyframes block to your CSS*/
      @keyframes signalanimate {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
      &:nth-of-type(1) {
        -webkit-animation: signalanimate 2s infinite;
        animation: signalanimate 2s infinite;
      }
      &:nth-of-type(2) {
        -webkit-animation: signalanimate 2s infinite;
        animation: signalanimate 2s infinite;
        -webkit-animation-delay: 0.5s;
        animation-delay: 0.5s;
      }
      &:nth-of-type(3) {
        -webkit-animation: signalanimate 2s infinite;
        animation: signalanimate 2s infinite;
        -webkit-animation-delay: 1s;
        animation-delay: 1s;
      }
    }
  }
`;
